import { useQuery } from "@tanstack/react-query";
import {
  buildPurchaseOrdersCountPayload,
  fetchPurchaseOrdersCount,
} from "../../services/purchaseOrders/purchaseOrdersApi";
import { poQueryCache } from "./cacheTimes";
import { purchaseOrderKeys } from "./queryKeys";

/**
 * KPI summary cards + quick-filter chip counts — merchant-scoped only.
 * Refetch on every listing visit (global default is refetchOnMount: false).
 * Also invalidated after PO create/update/delete/receive.
 */
export function usePurchaseOrdersCountQuery({
  auth,
  merchantId,
  enabled = true,
}) {
  return useQuery({
    queryKey: purchaseOrderKeys.count(merchantId),
    queryFn: ({ signal }) =>
      fetchPurchaseOrdersCount(
        buildPurchaseOrdersCountPayload(auth, merchantId),
        signal
      ),
    enabled: Boolean(enabled && merchantId && auth?.token),
    ...poQueryCache.count,
    refetchOnMount: "always",
  });
}
